module.exports = __webpack_public_path__ + "static/frostbyte2-d19da9da20a730f0f051ea5e891f7bcd.png";